import type { Route } from "@route-types/+types/landing.zh";
import { ResponseType } from "@sphtech/web2-core/ssr";
import heroZhDesktop from "../assets/landing/hero-zh-desktop.jpg";
import LandingPage from "../pages/LandingPage";

const BASE_URL =
  import.meta.env.VITE_SITE_BASE_URL ?? "https://e-paper.sph.com.sg";

const TITLE = "SPH 电子报";
const DESCRIPTION = "订阅SPH电子报，畅读海峡时报、联合早报等多种报刊。";
const EN_URL = `${BASE_URL}/`;
const CANONICAL = `${BASE_URL}/landing/zh`;
const OG_IMAGE = `${BASE_URL}${heroZhDesktop}`;

export function meta({}: Route.MetaArgs) {
  return [
    { title: TITLE },
    { name: "description", content: DESCRIPTION },
    { name: "robots", content: "index, follow" },
    { tagName: "link", rel: "canonical", href: CANONICAL },
    { property: "og:type", content: "website" },
    { property: "og:url", content: CANONICAL },
    { property: "og:title", content: TITLE },
    { property: "og:description", content: DESCRIPTION },
    { property: "og:image", content: OG_IMAGE },
    { property: "og:locale", content: "zh_SG" },
    {
      tagName: "link",
      rel: "alternate",
      hrefLang: "en",
      href: EN_URL,
    },
    {
      tagName: "link",
      rel: "alternate",
      hrefLang: "zh",
      href: CANONICAL,
    },
  ];
}

export function loader() {
  return {
    type: ResponseType.SUCCESS,
    statusCode: 200 as const,
    payload: {},
    lang: "zh",
  };
}

export default function LandingZhRoute() {
  return <LandingPage lang="zh" />;
}
